import React from 'react';
import {Box, CircularProgress} from '@mui/material';

const LoadingSpinner = () => {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
            <CircularProgress size={130} thickness={3}/>
        </Box>
    );
};

export default LoadingSpinner;
